import * as CubeTree from '../cubeTree/index';
import * as Toolkit from '../toolkit/index';
import FrontCubeData from '../frontCubeData/index';

function updateCubeList(cubeIds: Array<CubeId>): void {
    cubeIds.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        if (CubeTree.isShelf(cubeId)) {
            let shelf: CubeNode = CubeTree.findByCubeId(cubeId);
            let layers: Array<CubeId> = CubeTree.findChildCubeIds(cubeId);

            Toolkit.log({
                action: '更新',
                msgList: [
                    {
                        name: '货架更新, cubeId:',
                        value: shelf.id
                    }
                ]
            });
            shelf.update();
            updateCubeList(layers);
            return;
        }

        if (CubeTree.isPartition(cubeId)) {
            Toolkit.log({
                action: '更新',
                msgList: [
                    {
                        name: '层板更新, cubeId:',
                        value: cubeId
                    }
                ]
            });

            // 先执行一次层板更新，前端需要更新一些字段，否则有可能造成mainAlgorithm报错
            // cube.update();

            let stageWindow: StageWindow = window;

            // TODO: 容错，打孔需求
            let parentId: CubeId = CubeTree.findParentIdByCubeId(cube.id);
            let parentCube: CubeNode = CubeTree.findByCubeId(parentId);

            stageWindow.FILTER_OF_STAGECORE.mainAlgorithm(cube, parentCube, (res: FreeObjMap): void => {
                // mainAlgorithm会对数据做更改后，所以在这里需要强制更新一次前端数据
                updateLayerAndChildFrontData(cube.id);

                // 触发一次层板更新
                cube.update({
                    notLayout: false
                });

                let childCubeIds: CubeId[] = CubeTree.getChildCubeIds(cubeId);

                // 触发层板子级更新
                updateCubeList(childCubeIds);
            });
            return;
        }

        // 如果商品，更新自身即可
        Toolkit.log({
            action: '更新',
            msgList: [
                {
                    name: '商品更新, cubeId:',
                    value: cube.id
                }
            ]
        });
        cube.update();
    });
}

function updateLayerAndChildFrontData(cubeId: CubeId): void {
    // 更新层板的前端字段
    FrontCubeData.updateAllKeysByCubeId(cubeId);

    // 并且要更新此层板下的商品前端字段
    let childCubeIds: Array<CubeId> = CubeTree.getChildCubeIds(cubeId);

    childCubeIds.forEach((cubeId: CubeId): void => {
        FrontCubeData.updateAllKeysByCubeId(cubeId);
    });
}

export {
    updateCubeList
};
